import script from "./PaginationArrow.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginationArrow.vue?vue&type=script&lang=ts&setup=true"

import "./PaginationArrow.vue?vue&type=style&index=0&id=53e352a0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e352a0"]])

export default __exports__